import { render, staticRenderFns } from "./DropdownFilter.vue?vue&type=template&id=60878202&scoped=true"
import script from "./DropdownFilter.vue?vue&type=script&lang=js"
export * from "./DropdownFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60878202",
  null
  
)

export default component.exports